'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _blacklist = require('blacklist');

var _blacklist2 = _interopRequireDefault(_blacklist);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var ALERT_TYPES = ['danger', 'default', 'info', 'primary', 'success', 'warning', 'danger-inverted', 'default-inverted', 'info-inverted', 'primary-inverted', 'success-inverted', 'warning-inverted'];

var Pill = (function (_React$Component) {
    _inherits(Pill, _React$Component);

    function Pill(props) {
        _classCallCheck(this, Pill);

        _get(Object.getPrototypeOf(Pill.prototype), 'constructor', this).call(this, props);
        this.displayName = 'Pill';
    }

    _createClass(Pill, [{
        key: 'renderClearButton',
        value: function renderClearButton() {
            if (!this.props.onClear) return null;
            return _react2['default'].createElement('button', { type: 'button', onClick: this.props.onClear, className: 'Pill__clear' }, '×');
        }
    }, {
        key: 'render',
        value: function render() {
            var componentClass = (0, _classnames2['default'])('Pill', 'Pill--' + this.props.type, this.props.className);

            var props = (0, _blacklist2['default'])(this.props, 'className', 'label', 'onClear', 'onClick', 'type');
            props.className = componentClass;

            return _react2['default'].createElement('div', props, _react2['default'].createElement('button', { type: 'button', onClick: this.props.onClick, className: 'Pill__label' }, this.props.label), this.renderClearButton());
        }
    }]);

    return Pill;
})(_react2['default'].Component);

Pill.propTypes = {
    className: _propTypes2['default'].string,
    label: _propTypes2['default'].string.isRequired,
    onClear: _propTypes2['default'].func,
    onClick: _propTypes2['default'].func,
    type: _propTypes2['default'].oneOf(ALERT_TYPES)
};

Pill.defaultProps = {
    type: 'default'
};

module.exports = Pill;


//////////////////
// WEBPACK FOOTER
// /smarthelpnodeweb-ci-5863/workspace/Release_Build/~/kepler/lib/components/Pill.js
// module id = 974
// module chunks = 0 1